import { exists } from '@engine/lib/utility/exists';

function listenForTypeChange() {
  var $money_transfer_type = $('.money_transfer_type');
  var $money_transfer_sender_data = $('.money_transfer_sender_data');

  if (exists($money_transfer_type)) {
    $money_transfer_type.on('change', function () {
      if ($money_transfer_type.val() !== '') {
        $money_transfer_sender_data.removeClass('hidden');
      } else {
        $money_transfer_sender_data.addClass('hidden');
        $('input', $money_transfer_sender_data).val('');
        $('select option:selected', $money_transfer_sender_data).attr('selected', false);
        $('select', $money_transfer_sender_data).trigger('chosen:updated');
      }
    });
  }
}

var MoneyTransfer = {
  listenForTypeChange: listenForTypeChange
};
export default MoneyTransfer;